export const LOYALTY_SUMMARY_MONTHS_PERIOD = 2;
